import { TableRows } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SolaForceHeading } from '~/components/SolaForceHeading';
import { Enum } from '~/data/enums';

import {
  Competency,
  CoreCompetencyType,
  OtherCompetencyType,
  PosRelCompType,
  ProfCompType,
} from '../data/index';

import { CompLevel } from './CompLevel';
import { useSxStyles } from './useStyles';

type PropsType = {
  competenciesData?: Competency;
  competencyEnum: Enum[];
  compPosRelEnum: Enum[];
  compProfEnum: Enum[];
};

export const CompetencyTable = (props: PropsType) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const { competencyEnum, competenciesData, compPosRelEnum, compProfEnum } =
    props;

  const items = [1, 2, 3, 4, 5];

  const getEnumName = (enums: Enum[], val: string) =>
    enums.find((e: Enum) => e.code === val)?.name;

  return (
    <Box component="table" sx={sxStyles.table}>
      <caption>
        <SolaForceHeading
          headingIcon={<TableRows />}
          heading={t('laCompetencies')}
        />
      </caption>
      <Box component="thead">
        <Box component="tr">
          <Box component="th" sx={sxStyles.thCompetency}>
            {t('laCompetency')}
          </Box>
          <Box component="th" sx={sxStyles.thCompLevel}>
            {t('laSkillLevel')}
            <div>
              {items.map((item, index) => (
                <Box component="span" key={index} sx={sxStyles.cssScaleHd}>
                  {item}
                </Box>
              ))}
            </div>
          </Box>
          <Box component="th" sx={sxStyles.thTarget}>
            {t('laTargetLevel')}
            <div>
              {items.map((item, index) => (
                <Box component="span" key={index} sx={sxStyles.cssScaleHd}>
                  {item}
                </Box>
              ))}
            </div>
          </Box>
          <Box component="th" sx={sxStyles.thInfo}>
            {t('laInfo')}
          </Box>
        </Box>
      </Box>
      <tbody>
        {competenciesData?.coreCompetencies.map(
          (data: CoreCompetencyType, index: number) => {
            return (
              <tr key={index}>
                <td>{getEnumName(competencyEnum, data.fCompCoreCompetency)}</td>
                <td>
                  <CompLevel
                    items={items}
                    level={data.fCompCoreCompetencySkill}
                  />
                </td>
                <td>
                  <CompLevel
                    items={items}
                    level={data.fCompCoreCompetencyTarget}
                  />
                </td>
                <td>{data.fCompCoreCompetencyInfo}</td>
              </tr>
            );
          },
        )}
        {competenciesData?.otherCompetencies.map(
          (data: OtherCompetencyType, index: number) => {
            return (
              <tr key={index}>
                <td>{data.fCompOtherCompetency}</td>
                <td>
                  <CompLevel
                    items={items}
                    level={data.fCompOtherCompetencySkill}
                  />
                </td>
                <td>
                  <CompLevel
                    items={items}
                    level={data.fCompOtherCompetencyTarget}
                  />
                </td>
                <td>{data.fCompOtherCompetencyInfo}</td>
              </tr>
            );
          },
        )}
        {competenciesData?.posRelatedCompetencies.map(
          (data: PosRelCompType, index: number) => {
            return (
              <tr key={index}>
                <td>
                  {getEnumName(compPosRelEnum, data.fCompPosRelatedCompetency)}
                </td>
                <td>
                  <CompLevel
                    items={items}
                    level={data.fCompPosRelatedCompetencySkill}
                  />
                </td>
                <td>
                  <CompLevel
                    items={items}
                    level={data.fCompPosRelatedCompetencyTarget}
                  />
                </td>
                <td>{data.fCompPosRelatedCompetencyInfo}</td>
              </tr>
            );
          },
        )}
        {competenciesData?.profCompetencies.map(
          (data: ProfCompType, index: number) => {
            return (
              <tr key={index}>
                <td>{getEnumName(compProfEnum, data.fCompProfCompetency)}</td>
                <td>
                  <CompLevel
                    items={items}
                    level={data.fCompProfCompetencySkill}
                  />
                </td>
                <td>
                  <CompLevel
                    items={items}
                    level={data.fCompProfCompetencyTarget}
                  />
                </td>
                <td>{data.fCompProfCompetencyInfo}</td>
              </tr>
            );
          },
        )}
      </tbody>
    </Box>
  );
};
